import type { ProductSortToggleHandler } from "./product-sort-toggle-handler";

export class ProductSortToggleListener {
    private handler: ProductSortToggleHandler;

    public constructor(handler: ProductSortToggleHandler) {
        this.handler = handler;
    }

    public register(input: HTMLInputElement): void {
        input.addEventListener("change", () => {
            this.handler.handleSortChange(input);
        });
    }
}
